import {
  FETCH_EPISODE_DAY_FAILURE,
  FETCH_EPISODE_DAY_REQUEST,
  FETCH_EPISODE_DAY_SUCCESS,
  FETCH_EPISODE_LISTENERS_FAILURE,
  FETCH_EPISODE_LISTENERS_REQUEST,
  FETCH_EPISODE_LISTENERS_SUCCESS,
  FETCH_FEED_DAY_FAILURE,
  FETCH_FEED_DAY_REQUEST,
  FETCH_FEED_DAY_SUCCESS,
  FETCH_FEED_LISTENERS_FAILURE,
  FETCH_FEED_LISTENERS_REQUEST,
  FETCH_FEED_LISTENERS_SUCCESS,
  FETCH_SNAPSHOT_FAILURE,
  FETCH_SNAPSHOT_REQUEST,
  FETCH_SNAPSHOT_SUCCESS,
} from "./actionTypes";

interface StatsBucket<TData> {
  data: TData;
  loading: boolean;
  error: string | null;
}

export type ListenerCollection = {
  feed?: Record<string, unknown>;
  feed_episode?: Record<string, unknown>;
  listeners: Record<string, unknown>[];
  total_items: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  links: {
    next: string | null;
    prev: string | null;
  };
};

export interface StatsState {
  feedDay: StatsBucket<Record<string, unknown>>;
  episodeDay: StatsBucket<Record<string, unknown>>;
  feedListeners: StatsBucket<ListenerCollection>;
  episodeListeners: StatsBucket<ListenerCollection>;
  snapshot: StatsBucket<Record<string, unknown>>;
}

export const initialStatsState: StatsState = {
  feedDay: { data: {}, loading: false, error: null },
  episodeDay: { data: {}, loading: false, error: null },
  feedListeners: {
    data: {
      listeners: [],
      total_items: 0,
      total_pages: 0,
      current_page: 1,
      page_size: 0,
      links: { next: null, prev: null },
    },
    loading: false,
    error: null,
  },
  episodeListeners: {
    data: {
      listeners: [],
      total_items: 0,
      total_pages: 0,
      current_page: 1,
      page_size: 0,
      links: { next: null, prev: null },
    },
    loading: false,
    error: null,
  },
  snapshot: { data: {}, loading: false, error: null },
};

const statsReducer = (state = initialStatsState, action: { type: string; payload?: unknown }) => {
  switch (action.type) {
    case FETCH_FEED_DAY_REQUEST:
      return { ...state, feedDay: { ...state.feedDay, loading: true, error: null } };
    case FETCH_FEED_DAY_SUCCESS:
      return {
        ...state,
        feedDay: { data: action.payload as Record<string, unknown>, loading: false, error: null },
      };
    case FETCH_FEED_DAY_FAILURE:
      return {
        ...state,
        feedDay: { ...state.feedDay, loading: false, error: action.payload as string },
      };
    case FETCH_EPISODE_DAY_REQUEST:
      return { ...state, episodeDay: { ...state.episodeDay, loading: true, error: null } };
    case FETCH_EPISODE_DAY_SUCCESS:
      return {
        ...state,
        episodeDay: {
          data: action.payload as Record<string, unknown>,
          loading: false,
          error: null,
        },
      };
    case FETCH_EPISODE_DAY_FAILURE:
      return {
        ...state,
        episodeDay: { ...state.episodeDay, loading: false, error: action.payload as string },
      };
    case FETCH_FEED_LISTENERS_REQUEST:
      return { ...state, feedListeners: { ...state.feedListeners, loading: true, error: null } };
    case FETCH_FEED_LISTENERS_SUCCESS:
      return {
        ...state,
        feedListeners: {
          data: action.payload as ListenerCollection,
          loading: false,
          error: null,
        },
      };
    case FETCH_FEED_LISTENERS_FAILURE:
      return {
        ...state,
        feedListeners: { ...state.feedListeners, loading: false, error: action.payload as string },
      };
    case FETCH_EPISODE_LISTENERS_REQUEST:
      return {
        ...state,
        episodeListeners: { ...state.episodeListeners, loading: true, error: null },
      };
    case FETCH_EPISODE_LISTENERS_SUCCESS:
      return {
        ...state,
        episodeListeners: {
          data: action.payload as ListenerCollection,
          loading: false,
          error: null,
        },
      };
    case FETCH_EPISODE_LISTENERS_FAILURE:
      return {
        ...state,
        episodeListeners: {
          ...state.episodeListeners,
          loading: false,
          error: action.payload as string,
        },
      };
    case FETCH_SNAPSHOT_REQUEST:
      return { ...state, snapshot: { ...state.snapshot, loading: true, error: null } };
    case FETCH_SNAPSHOT_SUCCESS:
      return {
        ...state,
        snapshot: { data: action.payload as Record<string, unknown>, loading: false, error: null },
      };
    case FETCH_SNAPSHOT_FAILURE:
      return {
        ...state,
        snapshot: { ...state.snapshot, loading: false, error: action.payload as string },
      };
    default:
      return state;
  }
};

export default statsReducer;
